import React from 'react';
import { ChevronDown } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs } from '../data/mockData';

const FAQ = () => {
  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-12">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked <span className="text-green-600">Questions</span>
          </h2>
          <p className="text-lg text-gray-600">
            Got questions? We've got answers
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={faq.question} 
                value={`item-${index}`}
                className="bg-gradient-to-br from-green-50 to-white border-2 border-green-200 rounded-xl px-6 hover:border-green-600 transition-colors"
              >
                <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-green-600 py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-700 leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* Additional Info */}
          <div className="mt-8 text-center">
            <p className="text-gray-600">
              Still have questions?{' '}
              <a href="#enquiry" className="text-green-600 hover:text-green-700 font-semibold">
                Contact us directly
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
